var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 11.7711C4 15.1763 4 20.4907 4 20.4907C4 20.4907 4 20.4907 4 20.4907C4 21.8152 5.11929 22.8889 6.5 22.8889H21.5C22.8807 22.8889 24 21.8152 24 20.4907V11.2083M4 11.7711C4 11.3577 4.22202 10.9734 4.5875 10.7543L14 5.11108L23.3628 10.1632C23.7564 10.3755 24 10.7751 24 11.2083M4 11.7711C4.5 11.7711 14 17.7015 14 17.7015L24 11.2083",
    stroke: "#065EEA",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.3f5bde925d42d431db2905e16549d400.svg";
export { ForwardRef as ReactComponent };